export default __webpack_public_path__ + "assets/models/a2c7d4da403513a21784dc6ac3ccbd71.glb";